import { type FunctionComponent } from 'react';
import { CART_LINK } from '../../../constants/links';
import { useCartHeader } from '../../../hooks/apollo/cart-header/cart-header.hooks';
import { Badge } from '../../common-components/badge/badge.component';
import { IconWithLabelLink } from '../../common-components/link/icon-with-label-link/icon-with-label-link.component';
import ShoppingCartIcon from '../../svgs/untitled-ui/shopping-cart.svg';
import { cartBadgeStyles, cartLinkStyles, visibilityHidden, cartScale, containerStyles } from './cart-link.css';

type CartQuantityIndicatorProps = {
	quantity: number;
	isMinimizedHeader?: boolean;
	automationHook?: string;
};

const CartQuantityIndicator: FunctionComponent<CartQuantityIndicatorProps> = ({ quantity, isMinimizedHeader, automationHook }) => {
	const iconClass = isMinimizedHeader ? `f2 v-mid` : 'f3';
	const badgeClass = isMinimizedHeader ? cartBadgeStyles : '';
	return (
		<Badge count={quantity} className={badgeClass} condensed noMargin automationHook={automationHook}>
			<ShoppingCartIcon className={iconClass} data-testid="ShoppingCartIcon" />
		</Badge>
	);
};

export type CartLinkProps = {
	isMobile?: boolean;
	isMinimizedHeader?: boolean;
};

export const CartLink: FunctionComponent<CartLinkProps> = ({ isMobile = false, isMinimizedHeader }) => {
	const { quantity } = useCartHeader();
	const labelClass = `f7 dn-ns ${isMinimizedHeader ? visibilityHidden : ''} pt1 pt0-ns`;
	const automationHook = `header-cart${isMobile ? '-mobile' : ''}`;

	return (
		<IconWithLabelLink
			label="Cart"
			icon={
				<CartQuantityIndicator
					quantity={quantity}
					isMinimizedHeader={isMinimizedHeader}
					automationHook={`${automationHook}-count`}
				/>
			}
			ariaLabel={`View ${quantity} items currently in cart`}
			automationHook={automationHook}
			iconContainerClass={`h1 h-auto-ns ${!isMinimizedHeader ? cartScale : ''}`}
			containerClass={`${isMinimizedHeader ? '' : containerStyles}`}
			url={CART_LINK}
			theme="primary"
			linkClass={`pv2 pv0-ns w-100 flex justify-center db-ns ${cartLinkStyles}`}
			labelClass={labelClass}
		/>
	);
};
